<template>
  <div class="SearchStockOptions flex">
    <div class="flex search-stock-container">
      <el-select v-model="search_stock" filterable remote reserve-keyword
        placeholder="Search Indice/Stock Options Eg: Bank Nifty, Reliance" class="custom-seach-input" size="small"
        clearable :loading="loading" :remote-method="searchStockList" :disabled="isSearchDisable"
        @change="handleStock(search_stock)">
        <el-option v-for="stock in stocksList" :key="stock.id" :label="stock.title + ' ' + moment(stock.expiry).format('DD MMM YYYY')
          " :value="stock.id">
          <!-- <span class="searched-stock-title">{{ stock.symbol}}</span> -->
          <span class="searched-stock-title">{{
            stock.title + " " + moment(stock.expiry).format("DD MMM YYYY")
            }}</span>
          &nbsp;
          <!-- <span class="input-label-gray" v-if="stock.symbol">({{ stock.symbol }})</span> -->
        </el-option>
      </el-select>
      <i class="el-icon-search search-icon" v-if="!search_stock"></i>
    </div>
    <div
      class="flex strike-price-search-stock-container"
      v-if="$router.currentRoute.path != '/publish-recommendation-options'"
    >
      <el-select
        v-model="strikePrice"
        size="small"
        collapse-tags
        filterable
        clearable
        placeholder="Strike Price"
        class="custom-seach-input strike-price-seach-input left-margin-10"
        @change="getSelectedStrikeData(strikePrice)"
        v-on:scroll.passive="getStrikeDataCalBack()"
      >
        <el-option
          v-for="strike_data in strikeData"
          :key="strike_data.label"
          :label="strike_data.label"
          :value="strike_data.id"
        >
          {{ strike_data.label }}
        </el-option>
      </el-select>
    </div>

    <div style="font-size: 11px;
    border: 1px solid;
    padding: 2px 8px;
    border-radius: 10px;
    color: #409eff; margin-left: 5px;" @click="search_stock ? clearInputField() : ''"
      :style="[!search_stock ? { cursor: 'default' } : { cursor: 'pointer' }]"
      v-if="$router.currentRoute.path != '/publish-recommendation-options'">
      Clear
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import { EventBus } from "../eventBus";
import { some } from "lodash";
import axios from "axios";
import { derivativesApiCall } from "../mixins/DerivativesApi";
import moment from "moment";

export default {
  name: "SearchStock",
  mixins: [derivativesApiCall],

  data() {
    return {
      moment: moment,
      search_stock: [],
      selectActionType: "stock",
      isOpen: false,
      stocksList: [],
      showStockSearchBox: true,
      loading: false,
      isSearchDisable: false,
      selectedStock: {},
      strikePrice: "",
      strikeData: [],
    };
  },

  watch: {
    // search_stock(newStock, oldStock){
    //     if(newStock.trim().length){
    //         // this.searchStockList();
    //     }
    // },
  },

  mounted() {
    EventBus.$on("clearedSelectedFilter", (filter) => {
      this.search_stock = "";
    });

    EventBus.$on("selectedSector", (filter) => {
      this.search_stock = "";
    });

    EventBus.$on("selectedSearchedExpert", (filter) => {
      //emitted event from desktop and mobile filter
      this.search_stock = "";
    });

    EventBus.$on("selectPreviousStock", (stock) => {
      this.search_stock = stock.title;
    });

    EventBus.$on("removeSelectedStock", (stock) => {
      this.search_stock = "";
    });
    EventBus.$on("disableSearch", (isSearchDisable) => {
      this.isSearchDisable = isSearchDisable;
    });
  },

  methods: {
    searchStockList(query) {
      this.stocksList = [];
      // var url;
      // if (
      //   this.$route.name == "PastStrategyOptions" ||
      //   this.$route.name == "ExpertsPastStrategyOptions"
      // ) {
      //   url = `/options/scrips?q=${query}`;
      // } else {
      //   url = `/options/indices?q=${query}`;
      // }
      if (query) {
        this.loading = true;
        serverAddr
          .post(`/options/indices?q=${query}`)
          .then((response) => {
            if (response.data.status) {
              this.stocksList = response.data.data;
            } else {
              // this.isOpen = false;                            //closed searched stock result list
              this.stocksList = [];
            }
            this.loading = false;
          })
          .catch(
            function (error) {
              this.loading = false;
              console.log("error");
            }.bind(this)
          );
      }
    },

    clearInputField() {
      this.search_stock = "";
      this.strikePrice = "";
      this.strikeData = [];
      EventBus.$emit("selectedStock", "");
    },

    handleStock(item) {
      if (item) {
        let filtered_stock = this.stocksList.filter((e) => {
          return e.id == item;
        })[0];

        EventBus.$emit("selectedStock", filtered_stock);
        this.selectedStock = filtered_stock;
        this.stocksList = [];
        this.getStrikeDataCalBack();
      } else {
        EventBus.$emit("selectedStock", "");
        this.strikePrice = "";
        this.strikeData = [];
      }
    },

    getSelectedStrikeData(item) {
      if (item) {
        let filtered_strike = this.strikeData.filter((e) => {
          return e.id == item;
        })[0];
        EventBus.$emit("selectedStrike", filtered_strike);
        // this.strikeData = [];
      } else {
        this.strikePrice = "";
        EventBus.$emit("selectedStrike", "");
      }
    },

    //calculate protential return by target price(reco price) and current price
    getPotentailReturn(target_price, current_price) {
      target_price = Number(target_price);
      current_price = Number(current_price);

      if (target_price && current_price) {
        return (((target_price - current_price) / target_price) * 100).toFixed(
          2
        );
      }
      return 0;
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.SearchStockOptions .select-options-dropdown .el-input__inner {
  font-size: 0.8rem;
  height: 32px !important;
  border-bottom-left-radius: 40px;
  border-top-left-radius: 40px;
}

.SearchStockOptions .el-select-dropdown__item {
  line-height: 0;
}

.SearchStockOptions .search-stock-container {
  position: relative;
  width: 360px;
  // margin: 0 auto;
}

.SearchStockOptions .strike-price-search-stock-container {
  position: relative;
  width: 130px;
}

.SearchStockOptions .strike-price-seach-input {
  width: 120px;
}

.SearchStockOptions .filtered-stock-list-outer-container {
  position: absolute;
  top: 40px;
  border-radius: 4px;
  background-color: #fff;
  padding: 0px;
  width: 100%;
  box-sizing: border-box;
  max-height: 300px;
  overflow: auto;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 11;
}

.SearchStockOptions .filtered-stock-list-inner-container {
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}

.SearchStockOptions .filtered-stock-list-inner-container:hover {
  background-color: #f5f7fa;
}

.SearchStockOptions .filtered-stock-list-inner-container:hover .searched-stock-title {
  color: $primary-theme-color;
}

.no-data-found-section {
  margin-top: 50px;
}

.expertSelecBox {
  width: 375px;

  .el-input__inner {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    border: 1px solid #dcdfe6;
    border-left: none;
  }
}

@media screen and (max-width: 768px) {
  .SearchStockOptions .search-stock-container {
    max-width: 375px !important;
    width: 100%;

    .el-input--small {
      font-size: 11px;
    }
  }

  .SearchStock .strike-price-search-stock-container {
    max-width: 110px !important;
  }
}
</style>
